blue.ready('financialJourneyArticle', '.financialJourneyArticle', content => {
  let sidebar = content.querySelector('.financialJourneyArticle__sidebar');
  let sidebarItems = [...content.querySelectorAll('.sidebar-item')];
  let sidebarLinks = [...content.querySelectorAll('.sidebar-item a')];
  let sectionItems = [...content.querySelectorAll('.section-item')];

  sidebarItems[0].classList.add('active');

  sidebarLinks.forEach((link) => {
    link.addEventListener('click', () => {
      let href = link.getAttribute("href").replace('#', '');
      let offsetTop = sectionItems.find(e => e.id === href).offsetTop;

      // Scroll using smooth behavior (modern browsers)
      if ('scrollBehavior' in document.documentElement.style) {
        window.scroll({
          top: offsetTop,
          behavior: 'smooth'
        });
      } else {
        // Fallback for older browsers
        const scrollOptions = {
          top: offsetTop,
          left: 0,
          behavior: 'smooth'
        };
        document.body.scrollTop = offsetTop;
        document.documentElement.scrollTop = offsetTop;
      }
    });
  });

  window.addEventListener("scroll", (event) => {
    let fromTop = this.scrollY + sidebar.offsetHeight;
    let visibleItems = sectionItems.filter(el => { return (el.offsetTop < fromTop) })

    if (!visibleItems.length) {

        sidebarItems[0].classList.add('active');
    
      } else {

        let currentId = visibleItems[visibleItems.length - 1].id;

        sidebarItems.forEach((el) => {
            if (el.firstChild.getAttribute("href") === `#${currentId}`) {
              el.classList.add('active');
            } else {
              el.classList.remove('active');
            }

        })
    }
  })
});
